var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"toast-all"},[_c('div',{ref:"toastRef",staticClass:"toast",class:_vm.type},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.msg))])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }